"use client";

import { useTranslation } from "react-i18next";
import { SeriesItem } from "../types";

export function ChartProductCompetencyLegend({
  series,
}: {
  series: SeriesItem[];
}) {
  const [translate] = useTranslation(["dashboard"]);
  return (
    <div className="flex flex-wrap justify-center gap-6 mt-6 border-t border-secondary-500 pt-6 px-6">
      {series.map((s) => (
        <div key={s.key} className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full bg-${s.color}`} />
          <span className="text-base text-darkgray-600">
            {translate(s.label)}
          </span>
          <span className="text-sm text-darkgray-600">
            ({translate(s.description)})
          </span>
        </div>
      ))}
    </div>
  );
}
